export const TIMESHEETS_STATS_LOAD = 'TIMESHEETS_STATS_LOAD'
export const TIMESHEETS_STATS_LOAD_PENDING = 'TIMESHEETS_STATS_LOAD_PENDING'
export const TIMESHEETS_STATS_LOAD_FULFILLED = 'TIMESHEETS_STATS_LOAD_FULFILLED'
export const TIMESHEETS_STATS_LOAD_REJECTED = 'TIMESHEETS_STATS_LOAD_REJECTED'

export const TIMESHEETS_LOAD = 'TIMESHEETS_LOAD'
export const TIMESHEETS_LOAD_PENDING = 'TIMESHEETS_LOAD_PENDING'
export const TIMESHEETS_LOAD_FULFILLED = 'TIMESHEETS_LOAD_FULFILLED'
export const TIMESHEETS_LOAD_REJECTED = 'TIMESHEETS_LOAD_REJECTED'

export const TIMESHEET_LOAD = 'TIMESHEET_LOAD'
export const TIMESHEET_LOAD_PENDING = 'TIMESHEET_LOAD_PENDING'
export const TIMESHEET_LOAD_FULFILLED = 'TIMESHEET_LOAD_FULFILLED'
export const TIMESHEET_LOAD_REJECTED = 'TIMESHEET_LOAD_REJECTED'

export const ATTENDANCE_RECALCULATE = 'ATTENDANCE_RECALCULATE'
export const ATTENDANCE_RECALCULATE_PENDING = 'ATTENDANCE_RECALCULATE_PENDING'
export const ATTENDANCE_RECALCULATE_FULFILLED = 'ATTENDANCE_RECALCULATE_FULFILLED'
export const ATTENDANCE_RECALCULATE_REJECTED = 'ATTENDANCE_RECALCULATE_REJECTED'

export const DISMISS_TIMESHEET = 'DISMISS_TIMESHEET'
export const DISMISS_TIMESHEET_PENDING = 'DISMISS_TIMESHEET_PENDING'
export const DISMISS_TIMESHEET_FULFILLED = 'DISMISS_TIMESHEET_FULFILLED'
export const DISMISS_TIMESHEET_REJECTED = 'DISMISS_TIMESHEET_REJECTED'

export const APPROVE_TIMESHEET = 'APPROVE_TIMESHEET'
export const APPROVE_TIMESHEET_PENDING = 'APPROVE_TIMESHEET_PENDING'
export const APPROVE_TIMESHEET_FULFILLED = 'APPROVE_TIMESHEET_FULFILLED'
export const APPROVE_TIMESHEET_REJECTED = 'APPROVE_TIMESHEET_REJECTED'

export const TIMESHEETS_REVIEW_NOTIFICATION = 'TIMESHEETS_REVIEW_NOTIFICATION'
export const TIMESHEETS_REVIEW_NOTIFICATION_PENDING = 'TIMESHEETS_REVIEW_NOTIFICATION_PENDING'
export const TIMESHEETS_REVIEW_NOTIFICATION_FULFILLED = 'TIMESHEETS_REVIEW_NOTIFICATION_FULFILLED'
export const TIMESHEETS_REVIEW_NOTIFICATION_REJECTED = 'TIMESHEETS_REVIEW_NOTIFICATION_REJECTED'
